import Vue from "vue";
import { post, fetch, Del, put } from "../../../../ask/axios";
import menberMenu from '../../../../components/userCenter/public/menberPageMenu.vue'
import printlabelBox from '../../../../components/userCenter/public/printlabelBox.vue' //打印标签

export default {
  components: { menberMenu, printlabelBox },
  data() {
    return {
      api: {
        url: "",
        param: "",
        data: "",
        response: {},
        message: ""
      },

      titNames: "Air Freight Shipment",
      titUrls: ",",
      //订单编号
      OrderNO: "",
      //订单开始日期
      OrderStartTime: new Date(new Date().setDate(new Date().getDate() - 30)),
      OrderEndTime: new Date(),
      //日期输入处理,结束日期不能大于开始日期
      pickerBeginDateBefore: {
        disabledDate: time => {
          if (this.OrderEndTime) {
            return time.getTime() > Date.now() || time.getTime() > this.OrderEndTime;
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      //日期输入处理，结束日期不能大于开始日期
      pickerBeginDateAfter: {
        disabledDate: time => {
          // console.log("time:" + this.OrderStartTime);
          let startDate = new Date(this.OrderStartTime);
          return time.getTime() < startDate.getTime() || time.getTime() > Date.now();
        }
      },

      //按钮分类查询
      IsState: 1,

      //订单表格数据
      airListData: [],
      // airListData:[
      //   {
      //     AirOrder:{
      //       Id:'WA01907001063',AirCompanyCode:'CA',AirCompanyCode3:'999',Status:0,RefNO:'sdss',PackageQuanlity:2,VolumeCBM:2,OrderWeight:2,Volume:2,
      //       OrderServiceType:4,OrderAddType:0,
      //   },
      //   AirOrderInstore:{
      //     TotalWeight:12,TotalQuanlity:12,TotalVolume:12,TotalWeight:12,
      //   },
      //   AirOrderInfoBill:{
      //     Weight:12,Quanlity:1,Volume:2,
      //   },
      //   THConnectInfo:{
      //     CityName:'shenZhen',THBillNo:'123456',PlanCargoDate:'2019-12-12',PlanDeliveryTime:'2019-12-12',
      //   },
      //   THWayBill:{
      //     Id:2,
      //   },
      //   AirOrderExt:{
      //     StartCityNameCn:'3333'
      //   },
      //   NodeInfo:{
      //     CompleteTime:2019-12-12,
      //   }
      // }
      // ],

      isDataNone: false, //是否有渠道数据
      isLoading: false, //加载中...
      isData: false,
      //分页
      currentPage: 1, //当前页数
      pageSize: 20, //，每页显示的条数
      total: 0, //查询结果条数

      Status: [1, 2, 3, 4, 8],


      //打印标签
      OrderNOed: '',


      //--------复制订单弹框-------------//
      isAirOrderBox: false,
      PlanDeliveryTime: '',//货好时间，时间控件
      tipsRedBor: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      copyOrderRadio: 2,
      QueryGoodUnit: 1, //计算单位

      //按没件计算
      specInputList: [
        {
          Quanlity: '', Long: '', Wide: '', High: '', Weight: '', plaQuanlity: 'Same packages', plaLong: 'Length', plaWide: 'Width', plaHeight: 'Height', plaWeight: 'Weight of one box', isCol: false,
          unitOptions: [
            { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden case' }, { value: 4, label: 'Others' }
          ],
          unitValue: 1,
        },
      ],

      //按总量计算
      sumUnits: '',
      sumWeight: '',
      sumCBM: '',
      plaUnits: 'Total cartons',
      palSumWeight: 'Total weight',
      palSumVolu: 'Total volume',
      unitOptions: [
        { value: 'CTNS', label: 'Carton' }, { value: 'PLTS', label: 'Pallet' }, { value: 'WOODEN CASE', label: 'Wooden case' }, { value: 'OTHER', label: 'Others' }
      ],
      unitValue: 'CTNS',
      //验证文字颜色
      isCol: false,
      isCol2: false,
      isCol3: false,

      OrderItemInfo: {},//点击复制订单，存当前的列表数据

      isSelectChannelTrue: false, //渠道是否有效
    };
  },

  created() {
    //创建前
    this.clkSearchBtn()//查询按钮
  },
  mounted() {
    //载入dom后周期函数

  },
  watch: {},
  computed: {
    //计算属性周期函数
    urlTitle() { //链接头部
      return this.$apiEn
    },

    //货物总量计算
    totalUnits() { //总件数
      let num = 0
      //按没件包裹计算的总件数
      if (this.copyOrderRadio == 1) {
        this.specInputList.forEach(e => {
          num += Number(e.Quanlity)
        })
      } else if (this.copyOrderRadio == 2) {
        num = this.sumUnits
      }
      return num
    },
    totalKG() { //总重量
      let num = 0
      //按详细货物信息计算的总重量  并且是按照Kg/CBM 计算
      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 0) {
        this.specInputList.forEach(e => {
          num += Number(e.Weight * e.Quanlity)
        })
      }
      //按详细货物信息计算的总重量  并且是按照LB/CFT 计算
      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 1) {
        this.specInputList.forEach(e => {
          num += Number(e.Weight * e.Quanlity) * 0.4535924
        })
      }
      //总的货物信息 并且是按照Kg/CBM 计算
      if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 0) {
        num = this.sumWeight
      }
      //总的货物信息 并且是按照LB/CFT 计算
      if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 1) {
        num = this.sumWeight * 0.4535924
      }
      return num
    },
    totalCBM() {//总体积
      let num = 0
      //按没件包裹计算的总体积
      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 0) {
        this.specInputList.forEach(e => {
          num += ((e.Long * e.Wide * e.High) / 1000000) * e.Quanlity;
        })
      }

      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 1) {
        this.specInputList.forEach(e => {
          num += (((e.Long * 2.54) * (e.Wide * 2.54) * (e.High * 2.54)) / 1000000) * e.Quanlity;
        })
      }

      //总的货物信息 并且是按照Kg/CBM 计算
      if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 0) {
        num = this.sumCBM
      }
      //总的货物信息 并且是按照LB/CFT 计算
      if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 1) {
        num = this.sumCBM * 0.0283168
      }
      return num
    },

    //
    totalLB() {
      let sum = 0
      //按详细货物信息计算的总重量  并且是按照Kg/CBM 计算
      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 0) {
        this.specInputList.forEach(e => {
          sum += Number(e.Weight * e.Quanlity) * 2.2046226
        })
      }
      //按详细货物信息计算的总重量  并且是按照LB/CFT 计算
      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 1) {
        this.specInputList.forEach(e => {
          sum += Number(e.Weight * e.Quanlity)
        })
      }
      //按照货物总量计算
      if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 0) {
        sum = this.sumWeight * 2.2046226
      } else if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 1) {
        sum = this.sumWeight
      }
      return sum
    },
    totalCFT() {
      let sum = 0
      let num = 0
      //按没件包裹计算的总体积
      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 0) {
        this.specInputList.forEach(e => {
          num += (((e.Long * e.Wide * e.High) / 1000000) * e.Quanlity)
        })
        sum = num * 35.3147248;
      }

      if (this.copyOrderRadio == 1 && this.QueryGoodUnit == 1) {
        this.specInputList.forEach(e => {
          num += ((((e.Long * 2.54) * (e.Wide * 2.54) * (e.High * 2.54)) / 1000000) * e.Quanlity)
        })
        sum = num * 35.3147248;
      }
      //按照货物总量计算
      if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 0) {
        sum = this.sumCBM * 35.3147248
      } else if (this.copyOrderRadio == 2 && this.QueryGoodUnit == 1) {
        sum = this.sumCBM
      }
      return sum
    },
  },
  methods: {

    /*================分页开始==========================*/
    handleSizeChange(val) {
      this.pageSize = val
      this.clkSearchBtn()
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.clkSearchBtn()
    },

    //查询按钮
    clkSearchBtn() {
      this.airOrderListAPI()
    },
    //选中订单状态筛选订单
    clkBtnState(val) {
      this.IsState = val
      switch (val) {
        case 1:
          this.Status = [1, 2, 3, 4, 8]
          break;
        case 2:
          this.Status = [5]
          break;
        case 3:
          this.Status = [0, 6, 7]
          break;
      }

      this.clkSearchBtn(); //订单查询按钮
    },

    //-------------------------------列表查询信息---------------------------------//
    //查询列表接口
    //订单状态：0=未确认，1=已确认，2=已接单，3=已订舱，4=转运中，5=已完成，6=已退件，7=已撤销，8：派送中
    //进行中=1,2,3,4,8 ￥; 已完成=5，其他=0,6,7
    airOrderListAPI() {
      let that = this;
      that.OrderStartTime = !that.OrderStartTime ? '' : new Date(that.OrderStartTime).Format('yyyy-MM-dd 00:00:01')
      that.OrderEndTime = !that.OrderEndTime ? '' : new Date(that.OrderEndTime).Format('yyyy-MM-dd 23:59:59')
      this.api.param = {
        OrderNO: that.OrderNO.replace(/(^\s*)|(\s*$)/g, ""),//
        CreateTimeStart: that.OrderStartTime,//
        CreateTimeEnd: that.OrderEndTime,//
        Status: that.Status,//
        Skip: (this.currentPage - 1) * this.pageSize,
        Take: this.pageSize
      };
      that.isLoading = true; //加载中...
      that.isDataNone = false; //没有数据查无订单
      that.isData = false; //有数据列表

      this.api.url = this.$api04 + "/Air/api/AirOrder/AirOrderQuery"
      post(this.api.url, this.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.isLoading = false;
          that.isData = true;
          if (res.Results) {
            if (res.Results.length < 0 || res.Results.length == 0) {
              that.isDataNone = true;
              that.isDataNone != that.isLoading;
            } else {
              that.isDataNone = false;
            }
          }

          that.airListData = res.Results
          that.airListData.forEach(item => {
            // Vue.set(item,'isShowTh',false) //上门取件
            // Vue.set(item,'isShowDh',false) //自送显示
            // Vue.set(item,'isShowZs',false) //自送显示
            //是否点亮轨迹
            Vue.set(item, 'isTrackIcon01', false) //是否icon01
            Vue.set(item, 'isTrackIcon02', false)
            Vue.set(item, 'isTrackIcon03', false)
            Vue.set(item, 'isTrackIcon04', false)

            Vue.set(item, 'isShowText', true)

          })
          that.total = res.Total
          that.IsShowTrackStaus(); //轨迹显示判断

        } else {
          that.isLoading = false;
          that.isDataNone = true;
        }

      })
    },

    //----订单轨迹状态显示判断      
    IsShowTrackStaus() {
      this.airListData.forEach(item => {

        //轨迹图片点亮
        //未确认、已撤销、已退件的订单：都不点亮；
        if (item.AirOrder.Status == 0 || item.AirOrder.Status == 6 || item.AirOrder.Status == 7) {
          Vue.set(item, 'isTrackIcon01', false)
        } else {
          Vue.set(item, 'isTrackIcon01', true)
        }
        //起飞机场点亮
        if ((item.AirOrder.Status != 0 || item.AirOrder.Status != 6 || item.AirOrder.Status != 7) && item.NodeInfo && item.NodeInfo.StartAirArrTime) {
          Vue.set(item, 'isTrackIcon02', true)
        } else {
          Vue.set(item, 'isTrackIcon02', false)
        }
        //目的机场点亮
        if ((item.AirOrder.Status != 0 || item.AirOrder.Status != 6 || item.AirOrder.Status != 7) && item.NodeInfo && item.NodeInfo.DestAirArrTime) {
          Vue.set(item, 'isTrackIcon03', true)
        } else {
          Vue.set(item, 'isTrackIcon03', false)
        }
        //目的城市点亮
        if ((item.AirOrder.Status != 0 || item.AirOrder.Status != 6 || item.AirOrder.Status != 7) && item.NodeInfo && item.NodeInfo.CompleteTime) {
          Vue.set(item, 'isTrackIcon04', true)
        } else {
          Vue.set(item, 'isTrackIcon04', false)
        }
        //轨迹下方显示内容
        //未确认、已撤销的订单：仅显示下单时间。
        if (item.AirOrder.Status == 0 || item.AirOrder.Status == 7) {
          Vue.set(item, 'isShowText', false)
        } else {
          Vue.set(item, 'isShowText', true)
        }

      })

      //console.log('this.airListData  ' +  JSON.stringify(this.airListData));
    },

    //-//-----列表右侧按钮操作---------//
    //撤销按钮
    clkDelItemBtn(ord) {
      this.$confirm('Are you sure you want to cancel the selected order?', 'Cancel the order', {
        customClass: 'custom-message-box', //自定义添加Class
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
        closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
        showCancelButton: true,//去掉取消按钮
        showClose: false,//去掉右上角的取消（X）
        // type: 'warning',
        center: true
      }).then(() => {
        this.getDelApi(ord)
      }).catch(() => {

      });
      return false
    },
    //撤销订单接口
    getDelApi(ord) {
      let that = this;
      let WaybillNOArr = [{ WaybillNO: ord }]
      that.api.param = WaybillNOArr
      that.api.url = that.$api03 + "/api/TradeCustomer/AirOrder/CancleOrder";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.airOrderListAPI(); //刷新列表    
        } else if (res.IsOK == false) {
          that.$confirm('failed!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
            //this.getDelApi(ord)     
          }).catch(() => {

          });
          return false
        }

      })
    },
    //打印标签
    clkPrintBtn(ord, Qty) {
      this.OrderNOed = ord
      this.$refs.prantBox.clkDialog(Qty);
    },
    //打印标签是否成功
    printMsgEvent(msg) {
      if (msg == true) {
        this.airOrderListAPI();
      }
    },
    //查询接口
    GoodsVolApi(id, QueryGoodUnit) {
      let that = this
      that.api.param = {
        WaybillNO: id,
      }
      // async:false,
      that.api.url = this.$api03 + "/api/TradeCustomer/GoodsVolume/Query";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          //that.specInputList
          if (res.Results.length > 0) {
            if (QueryGoodUnit == 0) {
              res.Results.forEach(e => {
                let arr = {
                  unitValue: Number(e.Unit),
                  Quanlity: Number(e.Quanlity),
                  Long: Number(e.Long),
                  Wide: Number(e.Wide),
                  High: Number(e.High),
                  Weight: Number(e.Weight),
                  unitOptions: [
                    { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden case' }, { value: 4, label: 'Others' }
                  ],
                }
                //console.log('sdsd'  + JSON.stringify(that.specInputList));
                that.specInputList.forEach((k, index) => {
                  if (!k.Long && !k.Wide && !k.High && !k.Weight && !k.Quanlity) {
                    that.specInputList.splice(index, 1)
                  }
                })
                that.specInputList.push(arr)
              })
            } else if (QueryGoodUnit == 1) {
              res.Results.forEach(e => {
                let arr = {
                  unitValue: Number(e.Unit),
                  Quanlity: Number(e.Quanlity),
                  Long: Number(e.LongIN),
                  Wide: Number(e.WideIN),
                  High: Number(e.HighIN),
                  Weight: Number(e.WeightLB),
                  unitOptions: [
                    { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden case' }, { value: 4, label: 'Others' }
                  ],
                }
                //console.log('sdsd'  + JSON.stringify(that.specInputList));
                that.specInputList.forEach((k, index) => {
                  if (!k.Long && !k.Wide && !k.High && !k.Weight && !k.Quanlity) {
                    that.specInputList.splice(index, 1)
                  }
                })
                that.specInputList.push(arr)
              })
            }

          }
        }
      })
    },
    //--------复制订单--------------//
    async clkCopyBtn(item) {//复制按钮
      this.OrderItemInfo = item
      await this.SelectChannel(item, 1)

      if (this.isSelectChannelTrue == true) {
        this.copyOrderRadio = item.AirOrder.QueryGoodType //货件查询类型
        this.QueryGoodUnit = item.AirOrder.QueryGoodUnit //货件查询类型单位。0：厘米/KG，1：英寸/LB
        if (item.AirOrder.QueryGoodType == 2) {
          this.sumUnits = item.AirOrder.PackageQuanlity //下单件数
          this.unitValue = item.AirOrder.PackageUnit //下单单位
          if (item.AirOrder.QueryGoodUnit == 0) {
            this.sumWeight = item.AirOrder.Weight //下单重量
            this.sumCBM = item.AirOrder.VolumeCBM //下单体积
          } else if (item.AirOrder.QueryGoodUnit == 1) {
            this.sumWeight = item.AirOrder.WeightLB //下单重量
            this.sumCBM = item.AirOrder.VolumeCFT //下单体积
          }

        } else if (item.AirOrder.QueryGoodType == 1) {
          this.GoodsVolApi(item.AirOrder.WaybillNO, item.AirOrder.QueryGoodUnit) //查询材积接口
        }
        this.isAirOrderBox = true
      }

      //this.isAirOrderBox=false
    },
    //编辑订单按钮 
    async clkEditBtn(item) {
      if (item.AirOrder.Status == 0) {
        await this.SelectChannel(item, 2)

        if (this.isSelectChannelTrue == true) {
          this.$router.push({
            path: "/air/airEdit",
            query: { ord: item.AirOrder.WaybillNO }
          })
        } else {

        }
      } else {
        //window.location.href='/air/airOrderEdit?ord='+item.AirOrder.Id 
        this.$router.push({
          path: "/air/airEdit",
          query: { ord: item.AirOrder.WaybillNO }
        })
      }
    },

    //验证渠道是否有效
    async SelectChannel(item, tips) {
      let that = this
      that.api.param = {
        ChannelKey: item.AirOrder.AirChannelKey,
        DestAirPortCode3: item.AirOrder.DestinationCode,
        ArrivalType: item.AirOrder.AirArrivalType,
        TransferAirportCode3: item.AirOrder.TransferAirport,
        Weight: item.AirOrder.OrderWeight,
        CBM: item.AirOrder.VolumeCBM,
        GoodsReadyTime: item.AirOrder.PlanDeliveryTime,
      }
      // async:false,
      that.api.url = this.$api01 + "/api/InfoCustomer/AirCalculation/CalcTrafficEn";
      await post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          that.isSelectChannelTrue = true
        } else {
          that.isSelectChannelTrue = false
          // let infoTips=''
          //  if(tips==1){infoTips='复制失败，此渠道已失效！' }
          //  if(tips==2){ infoTips='此渠道已失效，请更换渠道下单！' }

          that.$confirm('This channel has expired, please change the channel to place an order!', "", {
            customClass: "custom-message-box", //自定义添加Class
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            cancelButtonClass: "btn-custom-cancel", //添加class,更换删除和取消按钮位置
            closeOnClickModal: false, //是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false, //去掉取消按钮
            showClose: false, //去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {

          }).catch(() => {

          });
          return false;
        }
      })
    },

    //---------复制订单弹框操作--------------------//
    addPackItem() {
      return {
        Quanlity: null, Long: null, Wide: null, High: null, Weight: null, plaQuanlity: 'Same packages', plaLong: 'Length', plaWide: 'Width', plaHeight: 'Height', plaWeight: 'Weight of one box', isCol: false,
        unitOptions: [
          { value: 1, label: 'Carton' }, { value: 2, label: 'Pallet' }, { value: 3, label: 'Wooden case' }, { value: 4, label: 'Others' }
        ],
        unitValue: 1,
      }
    },
    //货件信息
    addPackage() { //增加包裹
      this.specInputList.push(this.addPackItem())
    },
    delPackage(index) { //删除包裹
      if (this.specInputList.length > 1) {
        this.specInputList.splice(index, 1);
      }
    },
    clkCopyColseBtn() { //取消按钮
      this.isAirOrderBox = false
      this.isCol = false
      this.plaUnits = 'Total cartons'
      this.palSumWeight = 'Total weight'
      this.palSumVolu = 'Total volume'
      this.tipsRedBor = false
      this.specInputList = [this.addPackItem()]
    },
    changDate() { //时间改变
      if (this.PlanDeliveryTime) {
        this.tipsRedBor = false
      }
    },
    //确定按钮
    clkCopyConfirmBtn() {
      //console.log('this.OrderItemInfo ' +  JSON.stringify(this.OrderItemInfo));
      if (!this.PlanDeliveryTime) {
        this.tipsRedBor = true
        return false
      }
      let IsTrue = true
      if (this.copyOrderRadio == 1) {
        this.specInputList.forEach(e => {
          if (!e.Quanlity || !e.Long || !e.Wide || !e.High || !e.Weight) {
            e.plaQuanlity = 'Required'
            e.plaLong = 'Required'
            e.plaWide = 'Required'
            e.plaHeight = 'Required'
            e.plaWeight = 'Required'
            e.isCol = true
            IsTrue = false
            return false;
          }
        })

      } else if (this.copyOrderRadio == 2) {
        if (!this.sumUnits) {
          this.plaUnits = 'Required'
          this.isCol = true
          IsTrue = false
          return false;
        };
        if (!this.sumWeight) {
          this.palSumWeight = 'Required'
          this.isCol = true
          IsTrue = false
          return false;
        };
        if (!this.sumCBM) {
          this.palSumVolu = 'Required'
          this.isCol = true
          IsTrue = false
          return false;
        };
      }
      //
      if (IsTrue == true) {
        this.copyOrderApi();
      }

    },
    //复制订单接口
    copyOrderApi() {
      let that = this;
      that.api.param = {
        WaybillNO: this.OrderItemInfo.AirOrder.WaybillNO,
        PlanDeliveryTime: new Date(this.PlanDeliveryTime).Format('yyyy-MM-dd'),
        QueryGoodType: this.copyOrderRadio,
        PackageQuanlity: Number(this.totalUnits),
        Weight: Number(this.totalKG).toFixed(3),
        VolumeCBM: Number(this.totalCBM).toFixed(4),
      }
      if (this.copyOrderRadio == 2) {
        that.api.param.PackageUnit = this.unitValue
        that.api.param.GoodVolumeList = null ////材积信息
      } else {
        that.api.param.PackageUnit = 'PCS'
        //材积信息
        let goodsArr = []
        if (this.specInputList.length > 0) {
          this.specInputList.forEach(k => {
            let goodsObj = {
              Long: Number(k.Long),
              Wide: Number(k.Wide),
              High: Number(k.High),
              // Volume:((k.Long *k.Wide* k.High)/1000000)*k.Quanlity,
              Weight: Number(k.Weight),
              Quanlity: Number(k.Quanlity),
              Unit: k.unitValue,
              VolumeUnit: '',
              LongIN: '',
              WideIN: '',
              HighIN: '',
              VolumeCFT: '',
              WeightLB: '',
            }
            goodsArr.push(goodsObj)
          })
        }
        that.api.param.GoodVolumeList = goodsArr
      }

      that.api.url = that.$api03 + "/api/TradeCustomer/AirOrderEn/CopyOrder";
      post(that.api.url, that.api.param).then(function (res) {
        if (res.IsOK == true) {
          //window.location.href='/air/airOrderEdit?ord='+res.Results.WaybillNO
          that.$router.push({
            path: "/air/airEdit",
            query: { ord: res.Results.WaybillNO }
          })
        } else {
          that.$confirm('This channel is invalid and cannot be duplicated!', '', {
            customClass: 'custom-message-box', //自定义添加Class
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            cancelButtonClass: 'btn-custom-cancel', //添加class,更换删除和取消按钮位置
            closeOnClickModal: false,//是否可通过点击遮罩关闭 MessageBox
            showCancelButton: false,//去掉取消按钮
            showClose: false,//去掉右上角的取消（X）
            // type: 'warning',
            center: true
          }).then(() => {
          }).catch(() => {

          });
          return false

        }

      })
    },

    //----------货件信息验证-------------//
    checkNumInt(ctrValue) {
      if (ctrValue) { //只能输入正整数
        ctrValue = ctrValue.replace(/\D/g, '');
      }
      if (ctrValue == 0) {
        ctrValue = '';
      }
      //获取小数点前面的值
      let arr = ctrValue.split(".");
      let le = arr[0].length;
      if (le > 4) {
        ctrValue = arr[0].substring(0, 4);
      }
      return ctrValue;
    },
    //input重量失去焦点时验证
    weightBlur() { //总重量验证
      if (!this.sumWeight) {
        this.palSumWeight = 'Required'
        this.isCol2 = true
      }
      if (this.sumWeight == 0) {
        this.sumWeight = ''
      }
    },
    unitsBlur() { //总件数验证
      if (!this.sumUnits) {
        this.plaUnits = 'Required'
        this.isCol = true
      }
      if (this.plaUnits == 0) {
        this.plaUnits = ''
      }
    },
    CBMBlur() { //总体积验证
      if (!this.sumCBM) {
        this.palSumVolu = 'Required'
        this.isCol3 = true
      }
      if (this.sumCBM == 0) {
        this.sumCBM = ''
      }
    },
    //按每件包裹计算验证
    radCargoBlur(item) { //相同件数验证
      //console.log('val   '  + JSON.stringify(item))
      if (!item.Quanlity) {
        item.plaQuanlity = 'Required'
        return false
      };
      if (!item.Long) {
        item.plaLong = 'Required'
        return false
      };
      if (item.Long == 0) {
        item.Long = '';
        return false
      };
      if (!item.Wide) {
        item.plaWide = 'Required'
        return false
      };
      if (item.Wide == 0) {
        item.Wide = '';
        return false
      };
      if (!item.High) {
        item.plaHeight = 'Required'
        return false
      };
      if (item.High == 0) {
        item.High = '';
        return false
      };
      if (!item.Weight) {
        item.plaWeight = 'Required'
        return false
      };
      if (item.Weight == 0) {
        item.Weight = '';
        return false
      };
    },
    //体积数字验证
    checkNumCBM(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 5);
          }
        }
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }
        return ctrValue;
      }
    },
    //数字验证
    checkNum(ctrValue) {
      if (ctrValue) {
        ctrValue = ctrValue.replace(/[^\d\.]/g, '');
        if (ctrValue.indexOf('.') > -1) {
          let s = ctrValue.substring(ctrValue.indexOf('.') + 1)
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf('.') + 4);
          }
        }
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;

        if (le > 8) {
          let int = arr[0].substring(0, 8);
          if (ctrValue.indexOf('.') > -1) {
            ctrValue = int + '.' + arr[1];
          } else {
            ctrValue = int
          }
        }
        return ctrValue;
      }
    },
    //订单状态转换 
    transStatus(val) {
      // 新的：0=未确认，1=已确认，2=已接单，3=已订舱，4=转运中，5=已完成，6=已退件，7=已撤销，8：派送中
      if (val == 0) return 'Confirming'
      if (val == 1) return 'Confirmed'
      if (val == 2) return 'Received'
      if (val == 3) return 'Reserved'
      if (val == 4) return 'Delivering'
      if (val == 5) return 'Completed'
      if (val == 6) return 'Returned'
      if (val == 7) return 'Canceled'
      if (val == 8) return 'Distribute'
    },
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/userCenter/air/airList.js